var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",attrs:{"role":"status","aria-live":"assertive","aria-label":_vm.$t('loader.loading')}},[_c('LoaderBalls'),(_vm.rateLimitExceeded)?_c('div',[_c('p',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.$t('loader.rateLimitExceeded'))}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }